import type { QueryTerm } from '@atlassiansox/code-search-query-parser';

export const encodeQueryTerms = (terms: QueryTerm[]) =>
  terms
    .map(term => (term.type === 'phrase' ? `"${term.value}"` : term.value))
    .join(' ');
